export default (data) => ({
  type: 'SET_SEARCH_TERM',
  payload: data,
});
